import Header from "./components/Header";
import Hero from "./components/Hero";
import TickerBar from "./components/TickerBar";
import FeaturedEntries from "./components/FeaturedEntries";
import CategoryGrid from "./components/CategoryGrid";
import CollectionList from "./components/CollectionList";
import RankList from "./components/RankList";
import HowToUse from "./components/HowToUse";
import FaqSection from "./components/FaqSection";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <Header />
      <main className="flex-1">
        <Hero />
        <TickerBar />
        <FeaturedEntries />
        <CategoryGrid />
        <CollectionList />
        <RankList />
        <HowToUse />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}